/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import actions from '@src/redux/actions';
import { useDispatch } from 'react-redux';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { Box } from '@mui/material';
import { CloseRounded as CloseRoundedIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { StyledDrawer } from '../MobileTTS/NewVoiceDrawer/index.styled';
import Tasks from './Tasks';

const OnboardingDrawer = ({ open, onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <StyledDrawer anchor="bottom" open={open} onClose={onClose}>
      <Box
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          backgroundColor: COLOR.white,
        }}
        className="drawer-title"
      >
        <Typography variant="body-16-semibold" color={COLOR.darkGray}>
          {t('titlePopupOnboardingTasks')}
        </Typography>
        <CloseRoundedIcon sx={{ color: COLOR.navyBlue }} onClick={onClose} />
      </Box>
      <Tasks
        preventScroll
        onClose={() => {
          dispatch(actions.layout.setShowOnboardingPopupMobile(false));
        }}
      />
    </StyledDrawer>
  );
};

export default OnboardingDrawer;
